module.exports = __webpack_public_path__ + "static/media/ZvukPOZOR.45dcd7b0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/sounds/ZvukPOZOR.mp3
// module id = 808
// module chunks = 0